<template>
  <div>
    <Header :header-list="headerList" />
    <router-view class="router_content" />
    <Footer :info-list="footerObj" />
  </div>
</template>

<script>
import Header from './components/header'
import Footer from './components/footer'
// import { mapActions } from 'vuex'
import { getMenu } from '@/plugin/api'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      headerList: [],
      footerObj: {
        friUrl: [],
        contactList: [],
        codeUrl: ''
      }
    }
  },
  // created() {
  //   this.GenerateRoutes({ tenantId: 'sft' })
  // },
  mounted() {
    document.body.style.setProperty('--el-color-primary', '#00A59E')
    document.body.style.setProperty('--el-menu-hover-text-color', '#00A59E')
    this.getWebInfo()
  },
  methods: {
    // ...mapActions(['GenerateRoutes']),
    getMenu,
    getWebInfo() {
      this.getMenu({ tenantId: 'sft' }).then(res => {
        this.headerList = res.data.data.menuList
        this.$store.commit('SET_MENU_LIST', res.data.data.menuList)
        const fri = res.data.data.contentMainList.find(item => {
          return item.id === 2
        })
        const cont = res.data.data.contentMainList.find(item => {
          return item.id === 4
        })
        const ima = res.data.data.contentMainList.find(item => {
          return item.id === 5
        })
        this.footerObj.friUrl.push(...fri.contentItemTreeList)
        this.footerObj.contactList.push(...cont.contentItemTreeList)
        this.footerObj.codeUrl = ima.iconUrl
      })
    }
  }
}
</script>
